import { render, staticRenderFns } from "./card-youtube.vue?vue&type=template&id=53f9834a&scoped=true&"
import script from "./card-youtube.vue?vue&type=script&lang=js&"
export * from "./card-youtube.vue?vue&type=script&lang=js&"
import style0 from "./card-youtube.vue?vue&type=style&index=0&id=53f9834a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f9834a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
